import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from '@app/app-config.service';

@Component({
  selector: 'vfs-error-container',
  templateUrl: './error-container.component.html',
  styleUrls: ['./error-container.component.scss']
})
export class ErrorContainerComponent implements OnInit {
  public backgroundUrl;

  constructor(private router: Router, private appConfigService: AppConfigService) {}

  ngOnInit(): void {
    const assetsFolder = this.appConfigService.isExternal()
      ? `${this.appConfigService.getBlob()}/${this.appConfigService.getEnvName()}`
      : `../../../..`;
    this.backgroundUrl = `${assetsFolder}/assets/features/error/pages/error/error.png`;
  }
  goHome() {
    this.router.navigate(['/home']);
  }

  goContact() {
    window.location.href = 'https://www.vincle.com/es/contacto/';
  }
}
